const API_BASE_URL = 'https://et-pos.store';
const getAccountingApiUrl = () => `${API_BASE_URL}/connector/api/accounting`;

function getToken() {
  return localStorage.getItem('etpos_token') || '';
}

function headers() {
  return {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': `Bearer ${getToken()}`,
  };
}

async function request(method, path, body) {
  const opts = { method, headers: headers() };
  if (body) opts.body = JSON.stringify(body);
  const res = await fetch(`${getAccountingApiUrl()}${path}`, opts);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || data.error || `Request failed: ${res.status}`);
  return data;
}

export const accountingApi = {
  getDashboard:             (params)     => {
    const q = params ? '?' + new URLSearchParams(params).toString() : '';
    return request('GET', `/dashboard${q}`);
  },
  getAccountTypes:          ()           => request('GET',    '/account-types'),
  getAccountSubTypes:       (primaryType)=> request('GET',    `/get-account-sub-types?account_primary_type=${primaryType}`),
  getAccountDetailTypes:    (subTypeId)  => request('GET',    `/get-account-details-types?account_sub_type_id=${subTypeId}`),

  getAccounts:              ()           => request('GET',    '/accounts'),
  getTreeData:              ()           => request('GET',    '/tree-data'),
  getAccount:               (id)         => request('GET',    `/accounts/${id}`),
  createAccount:            (body)       => request('POST',   '/accounts', body),
  updateAccount:            (id, body)   => request('PUT',    `/accounts/${id}`, body),
  deleteAccount:            (id)         => request('DELETE', `/accounts/${id}`),
  getAccountLedger:         (id, params) => {
    const q = params ? '?' + new URLSearchParams(params).toString() : '';
    return request('GET', `/accounts/${id}/ledger${q}`);
  },
  activateDeactivateAccount:(id)         => request('GET',    `/accounts/${id}/activate-deactivate`),
  createDefaultAccounts:    ()           => request('GET',    '/create-default-accounts'),

  getJournalEntries:        ()           => request('GET',    '/journal-entries'),
  getJournalEntry:          (id)         => request('GET',    `/journal-entries/${id}`),
  createJournalEntry:       (body)       => request('POST',   '/journal-entries', body),
  updateJournalEntry:       (id, body)   => request('PUT',    `/journal-entries/${id}`, body),
  deleteJournalEntry:       (id)         => request('DELETE', `/journal-entries/${id}`),

  getTransactions:          (type)       => request('GET',    `/transactions${type ? '?transaction_type=' + type : ''}`),
  getMapDetails:            (id, type)   => request('GET',    `/transactions/map?id=${id}&type=${type}`),
  saveMapTransaction:       (body)       => request('POST',   '/transactions/save-map', body),
  saveNsfCheck:             (body)       => request('POST',   '/transactions/nsf-check', body),

  getTransfers:             ()           => request('GET',    '/transfers'),
  createTransfer:           (body)       => request('POST',   '/transfers', body),
  updateTransfer:           (id, body)   => request('PUT',    `/transfers/${id}`, body),
  deleteTransfer:           (id)         => request('DELETE', `/transfers/${id}`),

  getBudget:                (year)       => request('GET',    `/budget?financial_year=${year}`),
  saveBudget:               (body)       => request('POST',   '/budget', body),

  getTrialBalance:          ()           => request('GET',    '/reports/trial-balance'),
  getBalanceSheet:          ()           => request('GET',    '/reports/balance-sheet'),
  getArAgeing:              ()           => request('GET',    '/reports/ar-ageing'),
  getApAgeing:              ()           => request('GET',    '/reports/ap-ageing'),
  getArAgeingDetails:       ()           => request('GET',    '/reports/ar-ageing-details'),
  getApAgeingDetails:       ()           => request('GET',    '/reports/ap-ageing-details'),

  getSettings:              ()           => request('GET',    '/settings'),
  saveSettings:             (body)       => request('POST',   '/save-settings', body),
};

